import { Grid } from "@mui/material";
import NavSection from "./NavSections";
import logo from "../assets/images/Logo/transparency background/Little Haiti Global-08.png";
import { useAdminContext } from "../../hooks/UseAdminContext";
export default function SidebarContent({ setActiveSection }) {
  const { sectionList } = useAdminContext();
  const updatedSections = [
    {
      title: "Dashboard",
      value: "dashboard",
    },
    ...sectionList,
  ];
  return (
    <div>
      <div className="d-flex justify-content-center">
        <img
          src={logo}
          alt="Admin Portal Logo"
          className="mt-3"
          style={{ width: "150px", height: "auto" }}
        />
      </div>
      <Grid
        sx={{ p: 1, mt: 0, ml: 0.7, display: "flex", justifyContent: "center" }}
      />
      <NavSection
        sections={updatedSections}
        setActiveSection={setActiveSection}
      />
    </div>
  );
}
